<template>
  <v-container class="loading-container" fill-height>
    <v-row align="center" justify="center">
      <v-col cols="12" class="text-center">
        <v-progress-circular
          :size="150"
          :width="8"
          color="purple"
          class="mt-auto"
          indeterminate
        ></v-progress-circular>
        <h2 class="mt-10">
          {{ loadingMessage }}
        </h2>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import backend from "@/backend";

export default {
  name: "PaymentLoading",

  props: {
    paymentId: {
      type: String,
      required: true,
    },
  },

  data: () => ({
    payment: {},
    order: {},
    vendor: {},
    loadingMessage: "Laster inn betaling...",
  }),

  async created() {
    this.payment = await backend.get(`payments/${this.paymentId}/`, {});

    this.order = await backend.get(`orders/${this.payment.order}/`, {});

    this.vendor = await backend.get(`vendors/${this.order.vendor}/`, {});

    this.loadingMessage = "Vennligst vent...";

    const response = await backend.post(
      `payments/${this.paymentId}/process/`,
      {},
      {
        order: this.payment.order,
      }
    );

    if (response.success) {
      if (typeof response.redirect !== "undefined") {
        window.location = response.redirect;
      } else {
        this.$router.push({
          name: "vendor-order-placed",
          params: {
            vendorId: this.vendor.id.toString(),
            orderId: this.order.id.toString(),
          },
        });
      }
    } else {
      this.$router.push({
        name: "vendor-order-failed",
        params: {
          vendorId: this.vendor.id.toString(),
          orderId: this.order.id.toString(),
        },
      });
    }
  },
};
</script>
